const apiUrl = process.env.REACT_APP_API_URL;

export default class AdsService {
  static get(adsType: string) {
    return fetch(`${apiUrl}/api/partners/${adsType}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static handleError(error: Error): void {
    console.error(error);
  }
}
